import { NextApiRequest, NextApiResponse } from 'next';
import { IncomingMessage } from 'http';
import { DiscordResponse } from 'constants/discord';

export enum AuthStatus {
  Loading = 'LOADING',
  User = 'USER',
  Anonymous = 'ANONYMOUS',
}

export const HASURA_CLAIMS_KEY = 'https://hasura.io/jwt/claims';
// This should actually be an enym
export enum HasuraClaimKey {
  AllowedRoles = 'x-hasura-allowed-roles',
  DefaultRole = 'x-hasura-default-role',
  UserID = 'x-hasura-user-id',
  Subscriptions = 'x-hasura-subscriptions',
  OpraAgreement = 'x-hasura-opra-agreement-ends',
  LaunchAccess = 'x-hasura-launch-access-ends',
}

export interface HasuraClaims {
  [HasuraClaimKey.AllowedRoles]: string[];
  [HasuraClaimKey.DefaultRole]: string;
  [HasuraClaimKey.UserID]: string;
  [HasuraClaimKey.Subscriptions]: string;
  [HasuraClaimKey.OpraAgreement]: string;
  [HasuraClaimKey.LaunchAccess]: string;
}

export interface CustomClaims {
  [HASURA_CLAIMS_KEY]: HasuraClaims;
}

export enum Company {
  Facebook = 'facebook',
  Twitter = 'twitter',
  Google = 'google',
  Linkedin = 'linkedin',
  Discord = 'discord',
}

export interface IncomingMessageWithCookies extends IncomingMessage {
  cookies: {
    [key: string]: string;
  };
}

export const UNABLE_TO_OAUTH = {
  message: 'Unable to register your account using OAuth',
};

export enum OauthProvider {
  // Facebook = 'facebook',
  // Github = 'github',
  // Google = 'google',
  Discord = 'discord',
}

export type NextOauthApiHandler<T = any> = (
  req: NextApiRequest,
  res: NextApiResponse<T>,
  auth: DiscordResponse, // NOTE: Use union "|" if more providers are added
) => void | Promise<void>;

export interface StoredState {
  state: string;
  query?: string;
}

export const TEMP_FIREBASE_COOKIE = 'fbtoken';
